// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GAsaC7eW {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  z-index: 2001;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  padding: 1rem;
}
@media (max-width: 767px) {
  .GAsaC7eW {
    padding: 1rem;
  }
}
.suc4ymdU {
  position: relative;
  background: #ffffff;
  border-radius: 0.75rem;
  max-width: 25rem;
  width: 100%;
  padding: 3rem 1.5rem 2rem;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  -webkit-animation: Uu20LBJN 0.3s ease;
          animation: Uu20LBJN 0.3s ease;
}
@media (max-width: 767px) {
  .suc4ymdU {
    max-width: 90%;
    padding: 2rem 1rem 1.5rem;
    height: 18.75rem;
  }
}
.dciSjzjV {
  padding-top: 3rem;
}
@media (max-width: 767px) {
  .dciSjzjV {
    height: auto;
    min-height: 0;
  }
}
@-webkit-keyframes Uu20LBJN {
  from {
    opacity: 0;
    -webkit-transform: translateY(1.25rem);
            transform: translateY(1.25rem);
  }
  to {
    opacity: 1;
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
}
@keyframes Uu20LBJN {
  from {
    opacity: 0;
    -webkit-transform: translateY(1.25rem);
            transform: translateY(1.25rem);
  }
  to {
    opacity: 1;
    -webkit-transform: translateY(0);
            transform: translateY(0);
  }
}
.VFpHxQM9 {
  background: none;
  padding: 0;
  margin: 0;
  outline: none;
  font-family: inherit;
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  border: none;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  color: #585858;
}
.VFpHxQM9:hover {
  background: #e8e8e8;
}
.VFpHxQM9:active {
  -webkit-transform: scale(0.95);
          transform: scale(0.95);
}
@media (max-width: 767px) {
  .VFpHxQM9 {
    width: 1.75rem;
    height: 1.75rem;
  }
}
.dvoz7ICN {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  gap: 0.25rem;
  margin-bottom: 1.5rem;
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
          justify-content: flex-start;
}
.JunpAp6h {
  font-size: 1.25rem;
  font-weight: bold;
  color: #ff6b35;
}
.WjpHRrRg {
  width: 2.5rem;
  height: 2.5rem;
  -o-object-fit: contain;
     object-fit: contain;
  display: block;
  -webkit-flex-shrink: 0;
          flex-shrink: 0;
}
@media (max-width: 767px) {
  .WjpHRrRg {
    width: 2.25rem;
    height: 2.25rem;
  }
}
.n7q3u9bl {
  font-size: 1.125rem;
  font-weight: bold;
  color: #585858;
  text-align: left;
  margin: 0 0 1rem 0;
  line-height: 1.4;
}
@media (max-width: 767px) {
  .n7q3u9bl {
    font-size: 1rem;
  }
}
.ocZdGwOx {
  font-size: 1rem;
  color: #585858;
  text-align: left;
  line-height: 1.6;
  margin: 0;
  font-weight: bold;
}
@media (max-width: 767px) {
  .ocZdGwOx {
    font-size: 0.875rem;
  }
}
.pLKJetP6 {
  font-size: 1rem;
  color: #585858;
  text-align: center;
  line-height: 1.65;
  margin: 0;
  font-weight: 400;
  white-space: pre-line;
}
@media (max-width: 767px) {
  .pLKJetP6 {
    font-size: 0.875rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AccountGuideModal/AccountGuideModal.module.less","webpack://./src/styles/mixins.less"],"names":[],"mappings":"AAGA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,kCAAA;UAAA,0BAAA;EACA,aAAA;ECkBA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EDlBA,aAAA;AAAF;ACTE;EAAA;IDYE,aAAA;EACF;AACF;AAEA;EACE,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,yCAAA;EACA,qCAAA;UAAA,6BAAA;AAAF;ACxBE;EAAA;ID2BE,cAAA;IACA,yBAAA;IACA,gBAAA;EACF;AACF;AAEA;EACE,iBAAA;AAAF;AClCE;EAAA;IDqCE,YAAA;IACA,aAAA;EACF;AACF;AAEA;EACE;IACE,UAAA;IACA,sCAAA;YAAA,8BAAA;EAAF;EAEA;IACE,UAAA;IACA,gCAAA;YAAA,wBAAA;EAAF;AACF;AARA;EACE;IACE,UAAA;IACA,sCAAA;YAAA,8BAAA;EAAF;EAEA;IACE,UAAA;IACA,gCAAA;YAAA,wBAAA;EAAF;AACF;AAGA;ECgBE,gBAAA;EACA,UAAA;EACA,SAAA;EAEA,aAAA;EACA,oBAAA;EDnBA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EACA,eAAA;EACA,iCAAA;EAAA,yBAAA;EACA,cAAA;AAGF;AADE;EACE,mBAAA;AAGJ;AAAE;EACE,8BAAA;UAAA,sBAAA;AAEJ;AC5EE;EAAA;ID8EE,cAAA;IACA,eAAA;EAEF;AACF;AACA;EACE,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,YAAA;EACA,qBAAA;EACA,uBAAA;EAAA,mCAAA;UAAA,2BAAA;AACF;AAEA;EACE,kBAAA;EACA,iBAAA;EACA,cAAA;AAAF;AAGA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;KAAA,mBAAA;EACA,cAAA;EACA,sBAAA;UAAA,cAAA;AADF;ACrGE;EAAA;IDyGE,cAAA;IACA,eAAA;EAAF;AACF;AAGA;EACE,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AADF;ACnHE;EAAA;IDwHE,eAAA;EADF;AACF;AAIA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;AAFF;AChIE;EAAA;IDqIE,mBAAA;EADF;AACF;AAIA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,SAAA;EACA,gBAAA;EACA,qBAAA;AAFF;AC9IE;EAAA;IDmJE,mBAAA;EADF;AACF","sourcesContent":["@import '@/styles/variables.less';\n@import '@/styles/mixins.less';\n\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(4px);\n  z-index: @z-index-modal + 1; // 比登录弹窗层级更高\n  .flex-center();\n  padding: @spacing-md;\n\n  .mobile({\n    padding: @spacing-md;\n  });\n}\n\n.modal {\n  position: relative;\n  background: @white;\n  border-radius: @border-radius-lg;\n  max-width: 25rem; // 400px\n  width: 100%;\n  padding: @spacing-xxl @spacing-lg @spacing-xl;\n  box-shadow: @box-shadow-lg;\n  animation: slideUp 0.3s ease;\n\n  .mobile({\n    max-width: 90%;\n    padding: @spacing-xl @spacing-md @spacing-lg;\n    height: 18.75rem; // 300px\n  });\n}\n\n.modalBindGuide {\n  padding-top: 3rem; // 为右上角关闭按钮留出空间\n\n  .mobile({\n    height: auto;\n    min-height: 0;\n  });\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(1.25rem); // 20px\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.closeButton {\n  .button-reset();\n  position: absolute;\n  top: @spacing-md;\n  right: @spacing-md;\n  width: 2rem; // 32px\n  height: 2rem; // 32px\n  border-radius: 50%;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: @text-color;\n\n  &:hover {\n    background: darken(@background-color, 5%);\n  }\n\n  &:active {\n    transform: scale(0.95);\n  }\n\n  .mobile({\n    width: 1.75rem; // 28px\n    height: 1.75rem; // 28px\n  });\n}\n\n.logoSection {\n  display: flex;\n  align-items: center;\n  gap: @spacing-xs;\n  margin-bottom: @spacing-lg;\n  justify-content: flex-start;\n}\n\n.logoText {\n  font-size: @font-size-xl;\n  font-weight: bold;\n  color: #ff6b35; // 橙色\n}\n\n.idBadge {\n  width: 2.5rem; // 40px\n  height: 2.5rem; // 40px\n  object-fit: contain;\n  display: block;\n  flex-shrink: 0;\n\n  .mobile({\n    width: 2.25rem; // 36px\n    height: 2.25rem; // 36px\n  });\n}\n\n.title {\n  font-size: @font-size-lg;\n  font-weight: bold;\n  color: @text-color;\n  text-align: left;\n  margin: 0 0 @spacing-md 0;\n  line-height: 1.4;\n\n\n  .mobile({\n    font-size: @font-size-md;\n  });\n}\n\n.content {\n  font-size: @font-size-md;\n  color: @text-color;\n  text-align: left;\n  line-height: 1.6;\n  margin: 0;\n  font-weight: bold;\n\n  .mobile({\n    font-size: @font-size-sm;\n  });\n}\n\n.contentBindGuide {\n  font-size: @font-size-md;\n  color: @text-color;\n  text-align: center;\n  line-height: 1.65;\n  margin: 0;\n  font-weight: 400;\n  white-space: pre-line;\n\n  .mobile({\n    font-size: @font-size-sm;\n  });\n}\n\n","@import './variables.less';\n\n// 响应式 Mixins\n.mobile(@rules) {\n  @media (max-width: 767px) {\n    @rules();\n  }\n}\n\n.tablet(@rules) {\n  @media (min-width: 768px) and (max-width: 1023px) {\n    @rules();\n  }\n}\n\n.desktop(@rules) {\n  @media (min-width: 1024px) {\n    @rules();\n  }\n}\n\n.tablet-up(@rules) {\n  @media (min-width: 768px) {\n    @rules();\n  }\n}\n\n// Flexbox Mixins\n.flex-center() {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.flex-between() {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.flex-start() {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n// 文本省略\n.text-ellipsis() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.text-ellipsis-multi(@lines: 2) {\n  display: -webkit-box;\n  -webkit-line-clamp: @lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n// 清除浮动\n.clearfix() {\n  &::after {\n    content: '';\n    display: table;\n    clear: both;\n  }\n}\n\n// 按钮重置\n.button-reset() {\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  outline: none;\n  font-family: inherit;\n}\n\n// 触摸友好\n.touch-friendly() {\n  min-height: 2.75rem; // 44px\n  min-width: 2.75rem; // 44px\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `GAsaC7eW`,
	"modal": `suc4ymdU`,
	"slideUp": `Uu20LBJN`,
	"modalBindGuide": `dciSjzjV`,
	"closeButton": `VFpHxQM9`,
	"logoSection": `dvoz7ICN`,
	"logoText": `JunpAp6h`,
	"idBadge": `WjpHRrRg`,
	"title": `n7q3u9bl`,
	"content": `ocZdGwOx`,
	"contentBindGuide": `pLKJetP6`
};
export default ___CSS_LOADER_EXPORT___;
